import React from "react";
import AddCreditCard from "../addCreditCard/AddCreditCard";

interface CreditCardProps {
  businessData?: any;
  businessToken?: string | null;
  paymentDetails?: any;
  returnUrl?: string;
}

export default function CreditCard({
  businessData,
  businessToken,
  paymentDetails,
  returnUrl
}: CreditCardProps) {
  return (
    <AddCreditCard
      businessData={businessData}
      businessToken={businessToken}
      paymentDetails={paymentDetails}
      returnUrl={returnUrl}
    />
  );
}
